<template>
	<div>
		<input type="range" class="topcoat-range"
		       data-vv-name="slider"
		       v-validate="{ rules: { required: true, in: [targetValue] } }"
		step="1" min="0" max="4" value="0" list="numbers">
		<datalist id="numbers">
			<option>0</option>
			<option>1</option>
			<option>2</option>
			<option>3</option>
			<option>4</option>
		</datalist>
		<span class="arrow-down"
		      :class="{'is-danger': errors.has('slider') }"
		      :style="{left: leftPos + 'px' }"></span>
		<span v-show="errors.has('slider')"
		      class="help is-danger">
			X
		</span>
	</div>
	<!--<div class="control column is-2">-->
	<!--<label class="checkbox ">-->
	<!--<input type="checkbox"-->
	<!--:name="checkboxName"-->
	<!--v-validate="'required'">-->
	<!--Check Me-->
	<!--</label>-->
	<!--<p v-show="errors.has(checkboxName)"-->
	<!--class="help is-danger">-->
	<!--{{ errors.first(checkboxName) }}-->
	<!--</p>-->
	<!--</div>-->
</template>

<script>

	export default {
		data () {
			return {
				targetValue: 0,
				leftPos: 0,
			}
		},
//		computed: {
//			vali: function () {
//				return {rules: {required: true, in: [this.leftPos]}}
//			}
//		},
		created () {
			const pos = [3, 34, 65, 95, 126]
			this.targetValue = _.sample([1, 2, 3, 4])
			this.leftPos = pos[this.targetValue]
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.range, .topcoat-range {
		-webkit-appearance: slider-horizontal;
		width: 140px;
		margin-top: 4px;
	}

	div {
		position: relative;
	}

	.arrow-down {
		position: absolute;
		top: -2px;
		width: 0px;
		height: 0px;
		border-left: 5px solid transparent;
		border-right: 5px solid transparent;
		border-top: 5px solid #288edf;
	}
	.arrow-down.is-danger {
		border-top: 5px solid #ff3860;
	}
</style>



// WEBPACK FOOTER //
// Range.vue?da8ac9d4